import { useContext, useMemo } from 'react';
import { UserGroup } from '@round/api';
import { AuthContext } from '../modules/auth/AuthContext';
import { makeUserHasGroupAccess } from '../modules/auth/helpers';

export default function useCheckUserGroupAccess(groups: UserGroup[], hasAccessWhenMatched: 'all' | 'any' = 'all') {
    const authContext = useContext(AuthContext);
    const userHasGroupAccess = useMemo(
        () => makeUserHasGroupAccess(authContext.user?.groups ?? []),
        [authContext.user?.groups]
    );

    return useMemo(() => {
        if (authContext.loading) {
            return null;
        }

        return userHasGroupAccess(groups, hasAccessWhenMatched);
    }, [authContext.loading, groups, hasAccessWhenMatched, userHasGroupAccess]);
}
